import Fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchClauseCounts: ({
    category, code, queryUUID, clauseUUID,
  }, readStatus, config = fetchConfig()) => Fetch.useFetchDispatch(
    actions.FETCH_CLAUSE_COUNTS,
    readStatus,
    {
      category, code, queryUUID, clauseUUID,
    },
    config,
  ),
  useFetchClausesCounts: ({
    category, code, queryUUID, dictionaryCode,
  }, readStatus, config = fetchConfig([queryUUID, dictionaryCode])) => Fetch.useFetchDispatch(
    actions.FETCH_CLAUSES_COUNTS,
    readStatus,
    {
      category, code, queryUUID, dictionaryCode,
    },
    config,
  ),
};
